import firebase from 'firebase/app'
require('firebase/auth')
require('firebase/firestore')
require('firebase/storage')

let config = {
	apiKey: "AIzaSyACLYu7MK3SZID-pxaenvFRWF6OczMV7Co",
	authDomain: "nps-demo-55dec.firebaseapp.com",
	databaseURL: "https://nps-demo-55dec.firebaseio.com",
	projectId: "nps-demo-55dec",
	storageBucket: "nps-demo-55dec.appspot.com",
	messagingSenderId: "980133899187"
}

let FirebasePlugin = {
  db: () => firebase.database(),
  firestore: () => firebase.firestore(),
  auth: () => firebase.auth(),
  storage: () => firebase.storage(),
}

export default function (Vue) {
	firebase.initializeApp(config)
	FirebasePlugin.firestore().settings({ timestampsInSnapshots: true })
	Vue.prototype.$firebase = FirebasePlugin
}




// WEBPACK FOOTER //
// ./src/plugins/Firebase.js